import React, { useEffect, useState } from "react";

const HeaderBis = ({ backgroundImage, title, desc }) => {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    
    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    let textStrokeValue = "1px"; 
    if (screenWidth >= 768) {
        textStrokeValue = "2px"; 
    }
    if (screenWidth >= 1024) {
        textStrokeValue = "3px";
    }

    return (
        <header className="h-[500px] bg-cover bg-center text-[#ffffff] z-0" style={{ backgroundImage: `url(${backgroundImage})` }}>
            <div className="absolute h-[500px] inset-0 bg-black opacity-25 z-5"></div>

            <div className="h-full flex flex-col justify-center items-center text-center ">
                <h1
                    className={`font-customFont1 text-6xl font-black md:text-4xl lg:text-6xl transition-all duration-700 ease-in-out z-10`}
                    style={{
                        WebkitTextStroke: textStrokeValue,
                        textStroke: textStrokeValue,
                    }}
                >
                    {title}
                </h1>
                <h1 className={`font-customFont2 text-3xl font-bold md:text-4xl lg:text-5xl transition-all duration-700 ease-in-out z-10`}>
                    {desc}
                </h1>
            </div>
        </header>
    );
};

export default HeaderBis;
